import * as _ from 'lodash';
import { urlsConstants } from '../constants/url.constant';
import { defaultService } from './defaultService';

export const produtoBloqueadoService = {
  doGet,
  doSave,
  findByFiltro,
  doDelete,
};

function findByFiltro(options: Options, filter: any): Promise<any> {
  console.log(filter);

  const params = [];
  if (_.get(filter, 'produto.id')) {
    params.push(`produtoId=${encodeURIComponent(filter.produto.id)}`);
  }
  if (_.get(filter, 'cliente.codigoCliente')) {
    params.push(
      `codigoClienteParam=${encodeURIComponent(filter.cliente.codigoCliente)}`
    );
  }

  if (_.get(options, 'page') !== undefined) {
    params.push(`page=${options.page - 1}`);
  }
  const queryString = params.length ? `?${params.join('&')}` : '';
  return defaultService.doGet(
    `${urlsConstants.API_PRODUTO_BLOQUEADO}filtro${queryString}`,
    options
  );
}

function doDelete(id) {
  return defaultService.doDelete(`${urlsConstants.API_PRODUTO_BLOQUEADO}${id}`);
}

function doGet(id) {
  return defaultService.doGet(`${urlsConstants.API_PRODUTO_BLOQUEADO}${id}`);
}

function doSave(pb) {
  return defaultService.doSave(urlsConstants.API_PRODUTO_BLOQUEADO, pb);
}
